var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.showSpinnerLayer
    ? _c(
        "section",
        { staticClass: "lexon-view-container" },
        [
          _vm.renderGrid && _vm.parseGridConfiguration
            ? _c("GridTable", {
                ref: "grid",
                attrs: {
                  itemsData: _vm.isPortalUser ? _vm.listItems : _vm.expGridData,
                  itemsDataExport: _vm.serverSideDataExport,
                  gridConfiguration: _vm.parseGridConfiguration,
                  title: _vm.$t("views.expedients.title"),
                  toolbarOptions: _vm.toolbarOptionsCustom,
                  contextMenuItems: _vm.expedientGridContextMenuItems,
                  listName: _vm.listConfiguration["Alias"],
                  useServerPagination: _vm.useServerPagination,
                  context: _vm.context,
                  commandClick: _vm.commandClick,
                  allowGrouping: "",
                  archivedFilter: _vm.archivedSelectedOption,
                  usePersistSelection: true,
                  checkboxSelectColumn: true,
                },
                on: {
                  cellClicked: _vm.onCellClicked,
                  contextMenuClicked: _vm.onContextMenuClicked,
                  gridActionChange: _vm.gridActionChange,
                  gridExportData: _vm.gridExportData,
                  customToolbarContextMenuClick:
                    _vm.onCustomToolbarContextMenuClick,
                  toolbarClicked: _vm.onToolbarClicked,
                  contextMenuBeforeOpen: _vm.onContextMenuBeforeOpen,
                  checkboxChanged: _vm.handleCheckboxChanged,
                },
              })
            : _vm._e(),
          _vm.getShowImportExpedientDialog
            ? _c("ImportExpedientsDialogComponent", {
                key: _vm.getImportExpedientDialogKey,
                attrs: { showDialog: _vm.showImportExpedientDialog },
                on: { closeDialog: _vm.closeImportExpedientDialog },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }